import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, reactive, ref, Ref } from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useClickOutside } from '@/composables/clickOutside';
import { useColor } from '@/composables/color';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';
import CInput from '@/components/shared/CInput';
import CFileInput from '@/components/shared/CFileInput/CFileInput.vue';
import ColorSelector from './ColorSelector.vue';
import PreviewColorExample from '@/assets/images/preview-bg-color-example.png';
import PreviewImageExample from '@/assets/images/preview-img-example.png';
import type { FontColorOption } from '@/typings/customilyElements/canvasElements';
import type { ColorObject } from '@/typings/libraries';

interface CanvasBackground {
    imgFile?: File;
    width?: number;
    height?: number;
    bgColor?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewBackgroundModal',
  props: {
    background: null
  },
  emits: ["set-background", "cancel"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'set-background', value: CanvasBackground): void;
    (event: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    background?: CanvasBackground;
};

const DEFAULT_COLOR = '#EDE9FB';

const validation = {
    rules: 'required|min_value:600|max_value:1200',
    messages: {
        min_value: "The value is too small and it won't look good in your store",
        max_value: 'Use a smaller value, big values can result in bad performance and slow loading times on your store'
    }
};





const model = reactive({
    files: [] as File[],
    height: props.background?.height || 1000,
    width: props.background?.width || 1000,
    color: {
        hex: DEFAULT_COLOR,
        alpha: 1,
        cmyk: ''
    } as ColorObject
});

const pickerRef: Ref<HTMLElement | undefined> = ref();
const { clickOutsideActive } = useClickOutside(pickerRef, () => toggleColorSelection(), false);
const toggleColorSelection = () => {
    clickOutsideActive.value = !clickOutsideActive.value;
};

const onBgColorSelected = (color: FontColorOption) => {
    model.color = { ...color } as ColorObject;
    toggleColorSelection();
};

const { getColorFromString, hexToRgba } = useColor();
const rgbaColor = computed(() =>
    model.color.alpha >= 0 ? hexToRgba(model.color.hex, model.color.alpha) : DEFAULT_COLOR
);

const setBgColor = () => {
    setBackground({
        width: model.width,
        height: model.height,
        bgColor: rgbaColor.value
    });
};

const onImageUploaded = () => {
    setBackground({ imgFile: model.files[0] });
};

const setBackground = (background: CanvasBackground) => {
    emit('set-background', { ...background });
};

onBeforeMount(() => {
    if (!props.background?.bgColor) return;

    const color = getColorFromString(props.background.bgColor);
    model.color = {
        hex: color.hex,
        alpha: color.a,
        cmyk: ''
    };
});

return { __sfc: true,DEFAULT_COLOR, validation, props, emit, model, pickerRef, clickOutsideActive, toggleColorSelection, onBgColorSelected, getColorFromString, hexToRgba, rgbaColor, setBgColor, onImageUploaded, setBackground, ValidationProvider, ValidationObserver, CModal, CButton, CInput, CFileInput, ColorSelector, PreviewColorExample, PreviewImageExample }
}

})